/**
 * A task that re-schedules itself until a condition is met.
 */
export default class ReschedulingTask {

    /**
     * @param {Function} task Function to call after the condition is met.
     * @param {Function} condition Function that checks whether the task should run.
     * @param {Number} time Time (in milliseconds) between subsequent checks. (optional)
     */
    constructor(task, condition, time = 200) {
        this.task = task
        this.condition = condition
        this.time = time
        this.timeout = -1

        this.attemptToRun()
    }

    /**
     * Checks whether the condition is met and runs the task if it is.
     * Re-schedules the task otherwise.
     */
    attemptToRun() {
        if (this.condition()) {
            this.task()
            return
        }

        this.timeout = setTimeout(this.attemptToRun, this.time)
    }
}
